import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/logo-motomundi.png")